
import { ReactComponent as NexerSvg } from './Nexer.svg';

const Nexer = () => (
    <div className="companyName">
    <NexerSvg/>
    </div>
)

export default Nexer;
